import React from 'react'
import styles from './MarketingFaqList.module.css'

type MarketingFaqItem = {
  q: string
  a: string
}

type MarketingFaqListProps = {
  faqs: Array<MarketingFaqItem>
}

const MarketingFaqList = ({ faqs }: MarketingFaqListProps) => (
  <ul className={styles.list}>
    {faqs.map(faq => (
      <li key={faq.q} className={styles.listItem}>
        <p className={styles.question}>{faq.q}</p>
        <p className={styles.answer}>{faq.a}</p>
      </li>
    ))}
  </ul>
)

export default MarketingFaqList
